// eslint-disable-next-line no-restricted-imports -- Package consumers cannot import Forecast's application math module.
import { create, roundDependencies, unitDependencies } from 'mathjs'

export const measurementMath = create({ roundDependencies, unitDependencies })
